export const server = "https://kozatskyy.lviv.ua:3000";
export const newServer = 'http://134.209.249.249:3000';
export const devServer = "https://boiling-atoll-87395.herokuapp.com";
export const api = `${server}/api/v1/`;

